import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { isUserAdmin } from '../utils/adminUtils';
import { useToast } from '../context/ToastContext';
import { devLog } from '../utils/devLogger';
// WebSocket config import removed
import { supabase } from '../utils/supabase';

export function useAdminShortcuts() {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user) {
        const adminStatus = await isUserAdmin(user);
        setIsAdmin(adminStatus);
      }
    };
    
    checkAdminStatus();
  }, [user]);
  
  useEffect(() => {
    if (!isAdmin) return;
    
    const handleKeyPress = (e: KeyboardEvent) => {
      // Ctrl+Shift+S: Toggle Admin Settings Menu
      if (e.ctrlKey && e.shiftKey && e.key === 'S') {
        e.preventDefault();
        
        // Dispatch custom event to toggle settings menu
        window.dispatchEvent(new CustomEvent('toggleAdminSettings'));
        return;
      }
      
      // Ctrl+Shift+W: Toggle WebSocket mode
      if (e.ctrlKey && e.shiftKey && e.key === 'W') {
        e.preventDefault();
        
        const current = localStorage.getItem('websocket_proxy_mode');
        let next: string;
        
        if (!current || current === 'default') {
          next = 'direct';
        } else if (current === 'direct') {
          next = 'worker';
        } else {
          next = 'default';
        }
        
        if (next === 'default') {
          localStorage.removeItem('websocket_proxy_mode');
        } else {
          localStorage.setItem('websocket_proxy_mode', next);
        }
        
        showToast({
          type: 'info',
          message: `Switching to ${next} WebSocket mode...`,
          duration: 2000
        });
        
        setTimeout(() => window.location.reload(), 1000);
      }
      
      // Ctrl+Shift+D: Show notification debug info
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        const debugInfo = {
          notificationService: 'polling',
          pollingInterval: '30 seconds',
          supabaseClient: supabase
        };
        
        devLog.log('Notification Debug Info:', debugInfo);
        
        showToast({
          type: 'info',
          message: 'Notification debug info logged to console',
          duration: 3000
        });
      }
    };
    
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isAdmin, showToast]);
}